import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect }    from 'react-redux';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Checkbox,
  Radio
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import {
  bindActionCreators,
  compose
}                     from 'redux';

import DateTimePicker from 'react-datetime-picker';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import moment from 'moment';

import {
  Breadcrumb as BreadcrumbComponent
}                        from '../../../components';

import { getApiSetting, saveApiSetting } from '../../../redux/actions/siteActions';

let isLoading = "false";
class ApiSetting extends Component {
  constructor(props){
    super(props);
    this.state = {
      path: ['Home', 'API Setting'], 
      links: ["home",'/api-setting'],
      fb_app_id: '',
      fb_shared_id: '',
      fb_secret_key: '',
      google_map_key: '',
      show: false,
      alertMessage: '',
      msgType: '',
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
  }

  handleDismiss(){
  	this.setState({
  		show: false,
  		alertMessage: '',
  		msgType: '',
  	});
  }

  componentWillMount(){
    this.handPageChange();
  }

  handPageChange(){
  	isLoading = "true";
  	this.props.getApiSetting();
  }
  componentWillReceiveProps(nextProps){
  	if(this.props.apiDetail !== nextProps.apiDetail){
  		if(nextProps.apiDetail){
			if(nextProps.apiDetail.data){
				this.setState({
					fb_app_id: nextProps.apiDetail.data.fb_app_id,
				    fb_shared_id: nextProps.apiDetail.data.fb_shared_id,
				    fb_secret_key: nextProps.apiDetail.data.fb_secret_key,
				    google_map_key: nextProps.apiDetail.data.google_map_key,
				});
			}
			isLoading = "false";
		}
  	}

  	if(this.props.settingStatus !== nextProps.settingStatus){
  		if(nextProps.settingStatus){
			this.setState({
		  		show: true,
		  		alertMessage: nextProps.settingStatus.message,
		  		msgType: 'success',
		  	});

			this.handPageChange();
		}
  	}

  	if(this.props.error !== nextProps.error){
  		if(nextProps.error){
			this.setState({
		  		show: true,
		  		alertMessage: nextProps.error.message,
		  		msgType: 'danger',
		  	});

			this.handPageChange();
		}
  	}
  }

  handleChange = (e) => {
  	if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
  	this.setState({[e.target.name] : e.target.value })
  }

  validate = (e) => {
    let isError = true;
    
    if(!this.state.fb_app_id){
    	this.setState({fb_app_idError : 'red'});
    	isError = false;
    }

    if(!this.state.fb_shared_id){
    	this.setState({fb_shared_idError : 'red'});
    	isError = false;
    }

    if(!this.state.fb_secret_key){
    	this.setState({fb_secret_keyError : 'red'});
    	isError = false;
    }

    if(!this.state.google_map_key){
    	this.setState({google_map_keyError : 'red'});
    	isError = false;
    }

    return isError;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let isError = this.validate();
    if(isError){
      const constData = {
        fb_app_id: this.state.fb_app_id,
        fb_shared_id: this.state.fb_shared_id,
        fb_secret_key: this.state.fb_secret_key,
        google_map_key: this.state.google_map_key,
      }
      isLoading = "true";
      this.props.saveApiSetting(constData);
    }
  }

  render() {
    
  return (
    <div className="col-lg-12 add-sub-admin">
    {isLoading == "true" ? (
      <div className="loader">
        <p className="loading-message">
          <i>Loading...</i>
        </p>
        <div className="spinner">
          <div className="dot1" />
          <div className="dot2" />
        </div>
      </div>
    ) : (
      ""
    )}
    <div className="row">
      <div className="col-xs-12">
         <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
      </div>
    </div>
    <form>
      <div className="panel">
          <header className="panel-heading">API Setting</header>
          <div className="panel-body">
          {this.state.show && this.state.alertMessage !=='' &&  
          	<Row>      
              <Col md={12} xs={12}>
                <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
                  <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
                </Alert>
              </Col>
            </Row>
          }
          <Row>
	          <Col md={6} xs={6}>
	          	<FormGroup>
		            <ControlLabel>Facebook APP ID:</ControlLabel>
		            <FormControl
		              type="text"
		              placeholder="Facebook APP ID"
		              value={this.state.fb_app_id}
		              name="fb_app_id"
		              onChange={this.handleChange}
		              style={{borderColor:this.state.fb_app_idError}}
		            />
	            </FormGroup>
	          </Col>
	          <Col md={6} xs={6}>
	          	<FormGroup>
		            <ControlLabel>Facebook Share ID:</ControlLabel>
		            <FormControl
		              type="text"
		              placeholder="Facebook Share ID"
		              value={this.state.fb_shared_id}
		              name="fb_shared_id"
		              onChange={this.handleChange}
		              style={{borderColor:this.state.fb_shared_idError}}
		            />
	            </FormGroup>
	          </Col>
	          <Col md={6} xs={6}>
	          	<FormGroup>
		            <ControlLabel>Facebook Secret Key:</ControlLabel>
		            <FormControl
		              type="text"
		              placeholder="Facebook Secret Key"
		              value={this.state.fb_secret_key}
		              name="fb_secret_key"
		              onChange={this.handleChange}
		              style={{borderColor:this.state.fb_secret_keyError}}
		            />
	            </FormGroup>
	          </Col>
	          <Col md={6} xs={6}>
	          	<FormGroup>
		            <ControlLabel>Google Map API Key:</ControlLabel>
		            <FormControl
		              type="text"
		              placeholder="Google Map API Key"
		              value={this.state.google_map_key}
		              name="google_map_key"
		              onChange={this.handleChange}
		              style={{borderColor:this.state.google_map_keyError}}
		            />
	            </FormGroup>
	          </Col>
          </Row>
          
          <Row><hr/></Row>
          <Row>
            <Col md={12} xs={12}>
              <Button bsStyle="success" className="pull-right" onClick={this.handleSubmit}>Save</Button>
            </Col>
          </Row>
          </div>
      </div>
    </form>
    </div>
  )
  }
}

const mapStateToProps = (state,ownProps) => {
    return {
      error: state.siteReducer.error,
      apiDetail:  state.siteReducer.apiDetail,
      settingStatus:  state.siteReducer.settingStatus,
    };
};
export default compose(
  withRouter, 
  connect(mapStateToProps, {getApiSetting, saveApiSetting})
)(ApiSetting);



// WEBPACK FOOTER //
// ./src/app/views/admin/setting/ApiSetting.js